export const YES = 'Yes';
export const NO = 'No';
export const NEXT = 'Next';
export const ADD = 'Add';
export const CANCEL = 'Cancel';
export const REVIEW = 'Review';
export const CLOSE = 'Close';
export const OK = 'OK';
export const COMBINE = 'Combine';
export const DELETE = 'Delete';
export const UPLOAD = 'Upload';
export const CONTINUE = 'Continue';
export const SAVE = 'Save';
export const EXPORT = 'Export';
export const CREATE = 'Create';
export const SEARCH = 'Search';
export const VIEW = 'View';
export const VIEW_MORE = 'View more';
export const BUILD = 'Build';
export const EDIT = 'Edit';
export const EDITED = 'Edited';
export const ID = 'ID';
export const COPY = 'Copy';
export const SUBMIT = 'Submit';
export const SUCCESS = 'Success';
export const ERROR = 'Error';
export const SINGULAR = 'singular';
export const START = 'start';
export const TEXT = 'Text';
export const TEXT_LOWERCASE = 'text';
export const FILE = 'File';
export const ADMIN_USER = 'admin user';
export const SUPER_USER = 'super user';
export const DEPARTMENT_USER = 'department user';
export const USER = 'user';
export const USERS = 'Users';
export const ADD_BOX_CHOICE = 'Add box choice';
export const ADD_QUESTION = 'Add question';
export const EMAIL = 'email';
export const EMAIL_LABEL = 'Email';
export const LOGIN_FLOW = 'Choose your login flow';
export const SSO_PROVIDER_PBB = 'pbb';
export const SSO_PROVIDER_TYLER = 'tyler';
export const USERNAME = 'username';
export const PASSWORD = 'password';
export const PASSWORD_LABEL = 'Password';
export const LIGHT = 'light';
export const DARK = 'dark';
export const SPLIT = 'Split';
export const TABLE = 'Table';
export const CLEAR = 'Clear';
export const SELECT_ALL = 'Select all';
export const EXPENSE = 'Expense';
export const REVENUE = 'Revenue';
export const PREVIOUS = 'Previous';
export const INVENTORY = 'inventory';
export const VALIDATION = 'Validation';
export const BACK = 'Back';
export const SETTINGS = 'Settings';
export const BUDGET = 'Budget';
export const ORGANIZATION = 'Organization';
export const HOME = 'Home';
export const DISCARD = 'Discard';
export const FIRST = 'First';
export const LAST = 'Last';
export const PERSONAL = 'Personal';
export const SORT = 'Sort';
export const FILTERS = 'Filters';
export const FUND = 'Fund';
export const DEPT = 'Department';
export const DIV = 'Division';
export const BPA = 'BPA';
export const RESULT = 'Result';
export const QUARTILE = 'Quartile';
export const PERSONNEL = 'Personnel';
export const NONPERSONNEL = 'NonPersonnel';
export const SERVICE_TYPE = 'Service Type';
export const TOGGLE = 'Toggle';
export const COMPARE = 'Compare';
export const BUDGET_FOR_COMPARISON = 'Budget for comparison';
export const CURRENT_BUDGET = 'Current budget';
export const TOTAL_COST = 'Total cost';
export const REVENUE_COST = 'Revenue cost';
export const BEGIN = 'Begin';
export const ABBREVIATION = 'abbreviation';
export const SIMPLE = 'simple';
export const COMPOUND = 'compound';
export const COMMUNITY = 'Community';
export const GOVERNANCE = 'Governance';
export const COST_ALLOCATION = 'Cost allocation';
export const ORGANIZATION_LEVELS = 'Organization levels';
export const CATEGORY_TYPES = 'Category types';
export const SECTION = 'Section';
export const SIGN_IN = 'Sign in';
export const SIGN_OUT_OF_SSO= 'Sign out of SSO';
export const SIGN_IN_CARD_HEADING = 'Sign in to PBB';
export const GENERAL = 'General';
export const COST = 'Cost';
export const RESET = 'Reset';
export const RESTACK = 'Restack';
export const GROUP = 'Group';
export const SUMMARY = 'Summary';
export const ONGOING = 'Ongoing';
export const ONETIME = 'One time';
export const INCREASE = 'increase';
export const DECREASE = 'decrease';
export const MAIN = 'main';
export const ADDITIONAL = 'additional';
export const HIDE = 'Hide';
export const SHOW = 'Show';
export const DESCRIPTION = 'Description';
export const UPDATE = 'Update';
export const CONFIRM_PASSWORD = 'confirmPassword';
export const DETAILS = 'Details';
export const CREATED = 'Created';
export const REFINED = 'Refined';
export const GENERATE = 'Generate';
export const SIGN_OUT = 'Sign out';
export const GO_BACK = 'Go back';
export const SET = 'Set';
export const SEE_INFORMATION = 'See information';
export const ALL = 'All';
export const ASSESSED = 'Assessed';
export const ASSESSMENT = 'Assessment';
export const UNASSESSED = 'Unassessed';
export const AGREED = 'Agreed';
export const AGREEMENT = 'Agreement';
export const DISAGREED = 'Disagreed';
export const AGREE = 'Agree';
export const DISAGREE = 'Disagree';
export const ALLOCATION = 'Allocation';
export const ACTION = 'Action';
export const EXPAND = 'Expand';
export const SSO_LOGIN = 'Sign in with Tyler SSO';
export const NORMAL_LOGIN = 'Sign in with Tyler PBB ';
export const POSITIVE = 'Positive';
export const NEGATIVE = 'Negative';
export const REQUEST = 'Request';
export const PROGRAM = 'Program';
export const REMOVE = 'Remove';
export const CONFIGURE = 'Configure';
export const LEVEL = 'Level';
export const VIEW_INSIGHT = 'View insight';
export const DATA = 'Data';
export const GET_REPORT = 'Get report';
export const OPTIONS = 'Options';
export const REQUIRED = 'Required';
export const TYPE = 'Type';
export const QUESTION = 'Question';
export const MENU = 'Menu';
export const DOUBLE_CLICK_TO_EDIT = 'Double click to edit.';
export const USER_GROUP = 'User Group';
export const PROGRAM_DEPARTMENT = 'Program Department';
export const PROGRAM_DIVISION = 'Program Division';
export const PRIORITY = 'Priority';
export const SCORING_RUBRIC = 'Scoring Rubric';
export const APPLY = 'Apply';
export const PROGRAM_NUM = 'Program number';
export const IMPACT = 'Impact';
export const OPPORTUNITY = 'Opportunity';
export const PROGRAM_DESCRIPTION = 'Program description';
export const RECOMMEND = 'Recommend';
export const PROGRESS = 'Progress';
export const COMMENT = 'Comment';
export const AI_INSIGHT_GENERATION_LABEL = 'Get AI insight';
export const AI_INSIGHTS_GENERATION_LABEL = 'Get AI insights';
